import React from 'react';
import { checkString, checkArray } from '../helpers/global'

const Combi = props => {

  const { data } = props;
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};
  // if (checkArray(data.image_data)){
  //   img_src = data.image_data.toString();
  // }
  // if (!img_src) {

  //   img_src = data.image_url;
  // }
  img_alt = data.image_alt;

  if (checkArray(data.focal_point)) {
    focal_point = data.focal_point;
    combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }
  console.log(data)


  const dateRange = (timestamps) => {
    let start_date = 99999999999999999;
    let end_date = 0;

    for (const property in timestamps) {
      let performance_date = parseInt(timestamps[property]) * 1000;

      if (performance_date < start_date) {
        start_date = performance_date;
      }
      if (performance_date > end_date) {
        end_date = performance_date;
      }
    }
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const startFormatted = new Date(start_date).toLocaleDateString('en-GB', options);
    const endFormatted = new Date(end_date).toLocaleDateString('en-GB', options);


    return `${startFormatted} - ${endFormatted}`;


  };
  // if (data.performances ){
  //   data.display_date = dateRange(data.performances);
  // }


  return (

    <div className={"grid-item col-3  "} >
      <a href={data.url} className={"grid-item-inner bg-"}>
        {checkString(data.image_src) &&

          <div className="image-container" tabindex="-1">
            <div class="tags">
              {checkString(data.category) &&
                <div className="category font-medium font-label">{data.category}</div>
              }

            </div>
            <img loading="lazy" src={data.image_src} alt={data.image_alt} />
            {data.display_date && checkString(data.display_date) &&
              <div className=" date" dangerouslySetInnerHTML={{ __html: data.display_date }} />
            }
          </div>

        }
        <div className="content">

          <div dangerouslySetInnerHTML={{ __html: data.info }} />

          <h4 dangerouslySetInnerHTML={{ __html: data.title }} />

          {checkString(data.text) &&
            <p className="slot-text" dangerouslySetInnerHTML={{ __html: data.text }} />
          }


          <div className="arrow-button" aria-label={data.link_title}>
            {data.link_title}
          </div>





        </div>
      </a>
    </div>
  )
}

export default Combi;
